// extracted by css-extract-rspack-plugin
export default {"root":"Ha0RZnEQQk_mytzi","range":"l6o4jJr2U34owS1B"};